import { SET_USER } from '../actions/user';
import { User } from '../types/user';

export default (
  state: UserState = {},
  action: Record<string, any>
): UserState => {
  if (action.type === SET_USER) {
    return { ...state, current: action.payload };
  }
  return state;
};

export type UserState = {
  current?: User;
};
